import { render, staticRenderFns } from "./MailAppoint.vue?vue&type=template&id=2008dbfd&"
import script from "./MailAppoint.vue?vue&type=script&lang=js&"
export * from "./MailAppoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MailAppoint.vue"
export default component.exports